import {
	RECEIVE_BAD_REQUEST_NEW_APPLICATION_FORM_MESSAGE, RECEIVE_NEW_APPLICATION_FORM_MESSAGE,
	REQUEST_NEW_APPLICATION_FORM_MESSAGE
} from "./index";


export function requestNewApplicationFormMessage(){
	return {
		type: REQUEST_NEW_APPLICATION_FORM_MESSAGE
	}
}

export function receiveNewApplicationFormMessage(payload){
	return {
		type: RECEIVE_NEW_APPLICATION_FORM_MESSAGE,
		payload
	}
}

export function receiveBadRequestNewApplicationFormMessage(payload){
	return {
		type: RECEIVE_BAD_REQUEST_NEW_APPLICATION_FORM_MESSAGE,
		payload
	}
}
